export default __webpack_public_path__ + "static/media/ALREADY HAVE INSURANCE.207b5d09.mp3";